import { getResizedImageUrl } from '@wix/media-manager';
export const getLogoUrl = (logo, { maxWidth, maxHeight }) => {
    const logoFilename = logo?.match(/(?:[^\/]+)$/)?.[0];
    if (!logoFilename) {
        return;
    }
    if (logoFilename.endsWith('.svg')) {
        return `https://static.wixstatic.com/shapes/${logoFilename}`;
    }
    const resizedLogoUrl = getResizedImageUrl(logoFilename, maxWidth, maxHeight);
    return resizedLogoUrl.replace('/fill/', '/fit/');
};
//# sourceMappingURL=getLogoUrl.js.map